<template>
	<div class="create-page">
		<div class="create-content">
			<el-form ref="form" :model="form" label-position="top">
				<!-- 索赔申请 -->
				<div class="create-section">
					<h3>索赔申请</h3>
					<div class="type-list">
						<el-tooltip class="item" effect="dark" content="仅限直接从理光订购零件的代理商申请" placement="bottom" popper-class="create-tooltip">
							<div class="claim-type selected">
								理光单独订购零件
								<div class="tip">仅限直接从理光订购零件的代理商申请</div>
							</div>
						</el-tooltip>
					</div>
				</div>
				<!-- 申请方信息 -->
				<div class="create-section pb0">
					<h3>申请方信息：{{ form.applyOrgName }}</h3>
				</div>
				<!-- 索赔状态 -->
				<div class="create-section pb0">
					<h3>
						索赔状态
						<el-tag type="info">{{ auditStatusMsg }}</el-tag>
						<span class="number-span" v-if="form.serialNumber">编号：{{ form.serialNumber }}</span>
					</h3>
				</div>
				<!-- 日志 -->
				<div class="create-section log-section" v-if="logList.length > 0">
					<h3>日志</h3>
					<el-table :data="logList" :header-cell-style="{ color: '#444' }">
						<el-table-column prop="createTime" label="时间" width="160"></el-table-column>
						<el-table-column prop="createUsrCompany" label="执行方"></el-table-column>
						<el-table-column prop="createName" label="执行人" width="120"></el-table-column>
						<el-table-column prop="operNotes" label="事件"></el-table-column>
						<el-table-column prop="remark" label="批注"></el-table-column>
					</el-table>
				</div>
				<!-- 基本信息 -->
				<div class="create-section">
					<h3>基本信息</h3>
					<div class="grid-box">
						<div>
							<el-form-item label="机型及开发名" prop="repairDevices">
								<el-cascader
									v-model="form.repairDevices"
									:options="repairDeviceOptions"
									:props="{ value: 'id', label: 'name' }"
									:disabled="form.id ? true : false"></el-cascader>
							</el-form-item>
						</div>
						<div>
							<el-form-item label="机号" prop="repairDeviceNumber">
								{{ form.repairDeviceNumber }}
							</el-form-item>
						</div>
					</div>
					<div class="grid-box">
						<div>
							<el-form-item label="问题发生日" prop="partsClaimOrders.issueDate">
								{{ form.partsClaimOrders.issueDate }}
							</el-form-item>
						</div>
						<div>
							<el-form-item label="订单号" prop="partsClaimOrders.orderNumber">
								{{ form.partsClaimOrders.orderNumber }}
							</el-form-item>
						</div>
						<div>
							<el-form-item label="装箱单号" prop="partsClaimOrders.packingSlipNumber">
								{{ form.partsClaimOrders.packingSlipNumber }}
							</el-form-item>
						</div>
					</div>
					<div class="mr20">
						<el-form-item label="情况说明" prop="partsClaimOrders.situationDescription">
							{{ form.partsClaimOrders.situationDescription }}
						</el-form-item>
					</div>
					<div class="mr20">
						<el-form-item label="补充说明栏" prop="partsClaimOrders.additionalNotes">
							{{ form.partsClaimOrders.additionalNotes }}
						</el-form-item>
					</div>
				</div>
				<!-- 勾选项 -->
				<div class="create-section">
					<h3>勾选项</h3>
					<div class="radio-box">
						<p>事故类型勾选</p>
						<el-tag type="success" v-if="form.partsClaimOrders.issueType == '1'">开箱不良（发货15个工作日内提交，包装损坏签收单注明）</el-tag>
						<el-tag type="success" v-if="form.partsClaimOrders.issueType == '2'">品质事故（理光出库后90天以内，且非安装或使用不当造成）</el-tag>
					</div>
					<div class="radio-box" v-if="form.partsClaimOrders.issueType == '1'">
						<p>事故内容勾选</p>
						<el-tag type="success" v-if="form.partsClaimOrders.issueDetails == '1'">开箱损坏（外包装完好，未使用）</el-tag>
						<el-tag type="success" v-if="form.partsClaimOrders.issueDetails == '2'">物流损坏（拒收、签收注明）</el-tag>
						<el-tag type="success" v-if="form.partsClaimOrders.issueDetails == '3'">数量不足（实收数少于装箱单）</el-tag>
						<el-tag type="success" v-if="form.partsClaimOrders.issueDetails == '4'">数量过剩（实收数大于装箱数）</el-tag>
						<el-tag type="success" v-if="form.partsClaimOrders.issueDetails == '5'">发错（实收品与装箱单明细不符）</el-tag>
						<el-tag type="success" v-if="form.partsClaimOrders.issueDetails == '6'">遗漏（未收到装箱单上货品）</el-tag>
						<el-tag type="success" v-if="form.partsClaimOrders.issueDetails == '7'">其他</el-tag>
					</div>
				</div>
				<!-- 上传附件 -->
				<div class="create-section">
					<h3>上传附件</h3>
					<!-- 装箱单 -->
					<div class="upload-box">
						<h4>装箱单</h4>
						<FileList :file-list="packingListFileIdList" list-name="packingListFileIdList" class="mt4"></FileList>
					</div>
					<!-- 故障样张或照片 -->
					<div class="upload-box">
						<h4>故障样张或照片</h4>
						<FileList :file-list="faultSampleFileIdList" list-name="faultSampleFileIdList" class="mt4"></FileList>
					</div>
					<!-- 订购的故障零件，外包装等照片 -->
					<div class="upload-box">
						<h4>订购的故障零件，外包装等照片</h4>
						<FileList :file-list="packagingPhotosFileIdList" list-name="packagingPhotosFileIdList" class="mt4"></FileList>
					</div>
				</div>
				<!-- 机器零件信息 -->
				<div class="create-section">
					<h3>{{ partTitleObj[form.repairType] }}信息</h3>
					<!-- 动态生成的零件信息部分 -->
					<div class="flex part-info-box" v-for="(part, index) in form.partsDetailList" :key="index">
						<div class="flex-1">
							<div class="part-info-item">
								<div class="info-box">
									<p class="title">{{ partTitleObj[form.repairType] }}名称</p>
									<p class="content">{{ part.partsName }}</p>
								</div>
								<i class="el-icon-tickets" @click="$copyText(part.partsName)"></i>
							</div>
							<div class="part-info-item">
								<div class="info-box">
									<p class="title">{{ partTitleObj[form.repairType] }}编号</p>
									<p class="content">{{ part.partsNumber }}</p>
								</div>
								<i class="el-icon-tickets" @click="$copyText(part.partsNumber)"></i>
							</div>
							<div class="part-info-item" v-if="part.partsNumberNew != null">
								<div class="info-box">
									<p class="title">{{ partTitleObj[form.repairType] }}新编号</p>
									<p class="content">{{ part.partsNumberNew }}</p>
								</div>
								<i class="el-icon-tickets" @click="$copyText(part.partsNumberNew)"></i>
							</div>
							<div class="part-info-item">
								<div class="info-box">
									<p class="title">申请数量</p>
									<p class="content">{{ part.partsAmount }}</p>
								</div>
								<i class="el-icon-tickets" @click="$copyText(part.partsAmount)"></i>
							</div>
							<div class="part-info-item" v-if="part.partsBatchNumber != null">
								<div class="info-box">
									<p class="title">批号</p>
									<p class="content">{{ part.partsBatchNumber }}</p>
								</div>
								<i class="el-icon-tickets" @click="$copyText(part.partsBatchNumber)"></i>
							</div>
							<img class="watermark" v-if="part.lastResult == 1" src="@/assets/images/claim-fail.png" alt="" />
							<img
								class="watermark"
								v-if="part.currentAudit && part.currentAudit.auditStatus == 3"
								src="@/assets/images/claim-success.png"
								alt="" />
						</div>
						<div class="flex-1 part-info-box-right">
							<div v-if="[21, 25, 27].includes(auditStatus)">零件索赔进度： 实物审批中</div>
							<div class="right-item" v-if="part.partsTest">测试结果： {{ part.partsTest == 1 ? "正常" : "故障" }}</div>
							<div v-if="[7, -7, 29, 30].includes(auditStatus)">
								<div class="right-item">实物检测结果： {{ part.partsResult == 1 ? "拒绝" : "同意" }}</div>
								<div class="right-item">零件索赔进度：{{ progressMsg(part) }}</div>
								<el-button v-if="part.partsResult == 1 && part.partsClaimExpress" type="info" @click="checkAddressInfo(part.partsClaimExpress)">
									查看索赔退件信息
								</el-button>
								<div class="right-item" v-if="part.currentAudit && part.currentAudit.auditStatus == 2">
									预计发货时间： {{ part.estimatedShippingTime }}
								</div>
								<div v-if="part.currentAudit && part.currentAudit.auditStatus == 3" class="right-item">
									发货订单号：{{ part.partsClaimExpress.expressNumber }}
								</div>
								<div v-if="part.currentAudit && part.currentAudit.auditStatus == 3" class="right-item">
									发货操作时间(系统)：{{ part.currentAudit.operTime }}
								</div>
								<div v-if="part.currentAudit && part.currentAudit.auditStatus == 3" class="right-item">
									发货时间(录入)：{{ part.actualShippingTime }}
								</div>
								<div class="right-item word-bread-all" v-if="part.currentAudit && [2, 3, -2].includes(part.currentAudit.auditStatus)">
									发货批注： {{ part.currentAudit.remark }}
								</div>
								<div class="right-item flex" v-if="part.fileList.length > 0">
									<span>附件说明</span>
									<div class="flex-1">
										<FileList :file-list="part.fileList" class="mt4"></FileList>
									</div>
								</div>
								<div class="right-item" v-if="part.partsResult == 2 && part.partsClaimExpress">
									<el-button type="info" @click="checkAddressInfo(part.partsClaimExpress)">查看索赔邮寄信息</el-button>
								</div>
								<div class="right-item" v-if="part.partsClaimExpressTestReturn != null">
									<el-button type="info" size="small" @click="checkAddressInfo(part.partsClaimExpressTestReturn)">查看测试回寄信息</el-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</el-form>
		</div>
		<div class="create-footer">
			<el-button type="info" @click="handleBack">返回</el-button>
			<el-button type="primary" @click="handleDownloadPdf" v-if="[7].includes(auditStatus)">打印索赔报告书</el-button>
		</div>
		<ShowAddressInfo ref="showAddressInfo"></ShowAddressInfo>
		<!-- 现场技术报告书 -->
		<appendix2 ref="appendix2" />
	</div>
</template>

<script>
import { claimOrdersInfo } from "@/api/claim";
import FileList from "../components/FileList.vue";
import AddressInfo from "../components/addExpress.vue";
import ShowAddressInfo from "../components/showAddressInfo.vue";
import appendix2 from "@/components/PdfTemplate/AppendixReport/appendix2.vue";
export default {
	components: {
		FileList,
		AddressInfo,
		ShowAddressInfo,
		appendix2,
	},
	data() {
		return {
			// 申请方信息
			applyOptions: [],
			// 申请方人员信息
			applyUserList: [],
			// 机型及开发名
			repairDeviceOptions: [],
			form: {
				repairType: "2", // 索赔的类型 1、保修期内机器零件故障 2、理光单独订购零件 3、商品（耗材故障）
				applyOrgType: "", // 申请方信息-机构类型 1、网络店 2、特约维修店 3、代理商 4、分部
				applyOrgId: "", // 申请方信息 对应的机构id
				repairModelId: "", // 机型及开发名 一级
				repairDeviceId: "", // 机型及开发名 二级
				repairDeviceNumber: "", // 机号
				isSubmit: 0, // 是否提交 0否(表示暂存)  1是(提交索赔)
				repairDevices: [],
				//基本信息
				partsClaimOrders: {
					issueDate: "", // 问题发生日
					orderNumber: "", // 订单号
					packingSlipNumber: "", // 装箱单号
					situationDescription: "", // 情况说明
					additionalNotes: "", // 补充说明栏
					issueType: "", // 事故类型 1、开箱不良 2、品质事故
					issueDetails: "", // 事故内容勾选 1、开箱损坏 2、物流损坏 3、数量不足 4、数量过剩 5、发错 6、遗漏 7、其他
					packingListFileIdList: [], //装箱单上传文件的id
					faultSampleFileIdList: [], //故障样张或照片 上传文件的id
					packagingPhotosFileIdList: [], //订购的故障零件，外包装等照片 上传文件的id
				},
				// 机器零件信息
				partsDetailList: [],
			},
			// 装箱单附件列表
			packingListFileIdList: [],
			// 故障样张或照片附件列表
			faultSampleFileIdList: [],
			// 订购的故障零件，外包装等照片附件列表
			packagingPhotosFileIdList: [],
			// 机器零件列表
			partsDetailList: [],
			// 索赔管理员是否显示
			applyOrgFlag: false,
			// 资料审核管理员是否显示
			auditOrgFlag: false,
			// 订购信息
			partTitleObj: {
				1: "机器零件",
				2: "订购零件",
				3: "商品(耗材)",
			},
			// 索赔状态
			auditStatus: "",
			auditStatusMsg: "",
			logList: [],
		};
	},
	mounted() {
		// 获取机型及开发名
		this.getRepairDevice();
		// 获取单个索赔信息
		const claimId = sessionStorage.getItem("claimId") || this.$route.query.claimId;
		if (claimId) {
			this.getClaimOrdersInfo(claimId);
			this.getAuditLogList(claimId);
		} else {
			this.form.id ? delete this.form.id : "";
		}
	},
	methods: {
		// 获取审核日志
		getAuditLogList(claimId) {
			let self = this;
			self.$request.post("getAuditLogList", false, { id: claimId }, function (r) {
				if (r.code == "0") {
					let logList = [];
					for (const element of r.data) {
						if (element.remark) {
							logList.push(element);
						}
					}
					self.logList = logList;
					console.log("审核日志", self.logList);
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 获取单个索赔信息
		getClaimOrdersInfo(claimId) {
			let self = this;
			claimOrdersInfo(claimId, true)
				.then((r) => {
					if (r.code == "0") {
						sessionStorage.setItem("claimInfo", JSON.stringify(r.data));
						sessionStorage.setItem("claimId", r.data.id);
						sessionStorage.setItem("repairType", r.data.repairType);

						self.auditStatus = r.data?.currentAudit?.auditStatus;
						self.form.id = r.data.id;
						self.form.repairType = r.data.repairType;
						self.form.applyOrgName = r.data.applyOrgName;
						self.form.applyOrgType = String(r.data.applyOrgType);
						self.form.applyOrgId = r.data.applyOrgId;
						self.form.repairDeviceId = r.data.repairDeviceId;
						self.form.repairDeviceNumber = r.data.repairDeviceNumber;
						self.form = Object.assign({}, self.form, r.data);
						self.form.partsClaimOrders = {
							id: r.data.partsClaimOrders.id,
							issueDate: r.data.partsClaimOrders.issueDate, // 问题发生日
							orderNumber: r.data.partsClaimOrders.orderNumber, // 订单号
							packingSlipNumber: r.data.partsClaimOrders.packingSlipNumber, // 装箱单号
							situationDescription: r.data.partsClaimOrders.situationDescription, // 情况说明
							additionalNotes: r.data.partsClaimOrders.additionalNotes, // 补充说明栏
							issueType: String(r.data.partsClaimOrders.issueType), // 事故类型 1、开箱不良 2、品质事故
							issueDetails: String(r.data.partsClaimOrders.issueDetails), // 事故内容勾选 1、开箱损坏 2、物流损坏 3、数量不足 4、数量过剩 5、发错 6、遗漏 7、其他
							packingListFileIdList: [], //装箱单上传文件的id
							faultSampleFileIdList: [], //故障样张或照片上传文件的id
							packagingPhotosFileIdList: [], //订购的故障零件，外包装等照片上传文件的id
						};
						self.form.partsDetailList = [...r.data.partsDetailList];

						// 机型及开发名
						r.data.repairModelId ? (self.form.repairDevices = [r.data.repairModelId, r.data.repairDeviceId]) : [];
						self.packingListFileIdList = r.data.partsClaimOrders.packingListFileList;
						self.faultSampleFileIdList = r.data.partsClaimOrders.faultSampleFileList;
						self.packagingPhotosFileIdList = r.data.partsClaimOrders.packagingPhotosFileList;

						self.auditStatusMsg = r.data.currentAudit.operNotes;
						self.form.serialNumber = r.data.serialNumber;
					} else {
						self.$message.error(r.msg);
					}
				})
				.catch((error) => {
					console.log(error);
					// 错误处理已在拦截器中统一处理
				});
		},
		// 获取机型及开发名
		getRepairDevice() {
			let self = this;
			self.$request.get("getRepairDevice", false, {}, function (r) {
				if (r.code == "0") {
					// 删除最后一级的children属性
					for (const element of r.data) {
						for (let index = 0; index < element.children.length; index++) {
							const extAttr = element.children[index];
							delete extAttr.children;
						}
					}
					self.repairDeviceOptions = r.data;
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 返回列表页
		handleBack() {
			this.$router.push({
				path: sessionStorage.getItem("claimRoute"),
			});
		},
		// 查看索赔退件信息
		checkAddressInfo(partsClaimExpress) {
			this.$refs.showAddressInfo.init(partsClaimExpress);
		},
		// 索赔进度
		progressMsg(part) {
			let msg = "";
			if (part.partsResult == 1) {
				msg = "实物审批被拒";
			} else if (part.currentAudit) {
				if (part.currentAudit.auditStatus == 1) {
					msg = "实物审批已通过";
				} else if (part.currentAudit.auditStatus == 2) {
					msg = "无货等待";
				} else if (part.currentAudit.auditStatus == 3) {
					msg = "索赔成功";
				} else if (part.currentAudit.auditStatus == -2) {
					msg = "拒绝发货";
				} else {
					msg = "实物审批已通过";
				}
			} else {
				return "";
			}
			return msg;
		},
		// 下载pdf
		handleDownloadPdf() {
			// 默认模板
			const newForm = {
				...this.$data,
			};
			if (!newForm) {
				console.error("默认模板 data is undefined");
				return;
			}
			this.$refs.appendix2.init(newForm);
		},
	},
};
</script>

<style lang="scss" scoped>
.create-page {
	display: flex;
	flex-direction: column;
}
.create-tab {
	width: 160px;
	border-bottom: 2px solid #409eff;
	text-align: center;
	padding-bottom: 10px;
	margin-bottom: 20px;
}
.create-section {
	padding-bottom: 20px;
	border: 1px solid #ae8d5a;
	border-radius: 8px;
	h3 {
		height: 60px;
		line-height: 60px;
		padding: 0 20px;
		border-bottom: 1px solid #dcdfe6;
	}
}
.type-list {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr; /* 定义列 */
	gap: 20px; /* 间距 */
	margin: 20px 20px 0;
	.claim-type {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding: 34px 20px;
		border-radius: 4px;
		border: 2px solid rgba(0, 0, 0, 0.15);
		font-size: 20px;
		font-weight: 500;
		color: #aaa7a7;
		cursor: pointer;
		.tip {
			margin-top: 10px;
			font-weight: 500;
			font-size: 12px;
			color: #666;
			word-break: break-all;
		}
	}
	.selected {
		border-color: #409eff;
		color: #409eff;
	}
}
.grid-box {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr; /* 定义列 */
	gap: 20px; /* 间距 */
	margin: 0 20px;
	.el-cascader,
	.el-date-editor {
		width: 100%;
	}
}
.grid-box1 {
	grid-template-columns: 1fr 2fr; /* 定义列 */
}
/* 使用深度选择器 */
.el-form-item ::v-deep .el-form-item__label {
	padding: 0;
}
.hidden-label ::v-deep .el-form-item__label {
	opacity: 0;
}
.el-form-item1 ::v-deep .el-form-item__label {
	line-height: 20px;
}
.claim-user-box {
	margin: 0 20px;
	button {
		margin-left: 10px;
	}
}
.claim-user {
	color: rgba(0, 0, 0, 0.87);
	border: none;
	cursor: default;
	height: 34px;
	display: inline-flex;
	outline: 0;
	padding: 2px 10px;
	font-size: 0.8125rem;
	box-sizing: border-box;
	transition:
		background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
		box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
	align-items: center;
	white-space: nowrap;
	border-radius: 16px;
	vertical-align: middle;
	justify-content: center;
	text-decoration: none;
	background-color: #e0e0e0;
	cursor: pointer;
	img {
		color: transparent;
		width: 100%;
		height: 100%;
		object-fit: cover;
		text-align: center;
		text-indent: 10000px;
	}
}
.radio-box {
	margin: 0 20px;
	p {
		color: rgba(0, 0, 0, 0.54);
		padding: 0;
		font-size: 1rem;
		font-weight: 400;
		line-height: 1;
		letter-spacing: 0.00938em;
		margin: 10px 0;
	}
}
.el-radio ::v-deep .el-radio__inner {
	width: 20px;
	height: 20px;
}
.el-radio ::v-deep .el-radio__label {
	font-size: 16px;
	color: #000;
}
.upload-box {
	margin: 10px 20px;
	h4,
	p {
		margin-bottom: 10px;
	}
	p {
		color: rgba(0, 0, 0, 0.54);
		padding: 0;
		font-size: 1rem;
		font-weight: 400;
		line-height: 1;
		letter-spacing: 0.00938em;
	}
}
.upload-box ::v-deep .el-upload-dragger {
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 120px;
	width: 120px;
	.el-icon-upload {
		font-size: 40px;
		line-height: unset;
		margin: unset;
	}
}
.create-footer {
	display: flex;
	div {
		flex: 1;
	}
	margin-top: 10px;
}
.fixed-btn-box {
	position: fixed;
	top: 80px;
	right: calc(10vw - 80px);
	button {
		display: block;
		margin-left: 0;
		margin-bottom: 10px;
	}
}
.flex {
	display: flex;
}
.flex-1 {
	flex: 1;
	padding: 10px;
}
.part-info-box {
	margin: 10px 20px;
	box-shadow:
		0px 2px 1px -1px rgba(0, 0, 0, 0.2),
		0px 1px 1px 0px rgba(0, 0, 0, 0.14),
		0px 1px 3px 0px rgba(0, 0, 0, 0.12);
	border-radius: 5px;
	.delete-btn-box {
		text-align: right;
		font-size: 20px;
		cursor: pointer;
		padding-right: 5px;
	}
	.flex-1 {
		position: relative;
		min-width: 0;
		word-wrap: break-word;
		.watermark {
			width: 100px;
			position: absolute;
			top: 0;
			right: 0;
		}
	}
}
.part-info-item {
	display: flex;
	align-items: flex-end;
	.el-form-item {
		flex: 1;
		margin-bottom: 5px;
	}
	.info-box {
		flex: 1;
		.title {
			margin-top: 10px;
		}
		.content {
			border: 1px solid #ddd;
			border-radius: 5px;
			padding: 9px 12px;
			margin-top: 5px;
			font-size: 13px;
		}
	}
	i {
		font-size: 28px;
		cursor: pointer;
		margin-bottom: 10px;
	}
}
.part-info-box-right {
	background-color: rgba(0, 0, 0, 0.02);
	font-size: 16px;
	.right-item {
		margin-bottom: 10px;
		.flex-1 {
			padding-top: 0;
		}
	}
}
.mt20 {
	margin-top: 20px;
}
.ml20 {
	margin-left: 20px;
}
.color-red {
	color: red;
}
.mr20 {
	margin: 0 20px;
}
.notice {
	color: #409eff;
	display: inline-block;
	text-decoration: underline;
	margin-left: 30px;
	cursor: pointer;
}
iframe {
	width: 100%;
	height: 70vh;
}
.subtitle {
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.75;
	letter-spacing: 0.00938em;
	margin: 0 20px;
}
.border-bottom-none {
	border-bottom: none !important;
}
.pb0 {
	padding-bottom: 0;
}
.height45 {
	height: 45px !important;
}
.add-section {
	margin: 0 20px;
	.title1,
	.el-input,
	.el-button {
		margin-top: 10px;
	}
	.title2 {
		color: #909399;
		font-size: 12px;
	}
}
.number-span {
	float: right;
	font-size: 16px;
	font-weight: normal;
}
.word-bread-all {
	white-space: pre-line;
	word-break: break-all;
}
.log-section {
	.el-table {
		margin-left: 20px;
		width: calc(100% - 40px);
		margin-top: 20px;
		font-size: 12px;
	}
}
</style>
<style>
.create-tooltip {
	width: 220px;
}
</style>
